import React from "react";
import { useSelector } from "react-redux";
import { ViewComponent } from "./ViewComponent";
import { selectUserPosition } from "../../../../model/system/selectors";
import { POSITION_WITH_FULL_ACCESS } from "../../../../constants/userPositions";
import {
  navigationMenu,
  typeSidebarData,
  navigationMenuSlim,
} from "./constants";

export type typeSidebar = {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Sidebar: React.FC<typeSidebar> = ({
  sidebarOpen,
  setSidebarOpen,
}) => {
  const position = useSelector(selectUserPosition);

  const [menuObject, setMenuObject] = React.useState(
    POSITION_WITH_FULL_ACCESS.includes(position!)
      ? navigationMenu
      : navigationMenuSlim,
  );

  React.useEffect(() => {
    if (position) {
      const menu = POSITION_WITH_FULL_ACCESS.includes(position)
        ? navigationMenu
        : navigationMenuSlim;

      setMenuObject(menu);
    }
  }, [position]);

  const refreshMenu = (menu: typeSidebarData) => {
    return menu.map((item) => {
      // Clear whole object
      item.current = false;
      if (item.children) {
        item.children.map((subItem) => (subItem.current = false));
      }

      // Set current marker
      if (window.location.pathname.startsWith(item.href) && !item.children) {
        item.current = true;
      } else if (item.children) {
        item.children.map((subItem) => {
          if (window.location.pathname.startsWith(subItem.href)) {
            item.current = true;
            subItem.current = true;
          }
          return subItem;
        });
      }
      return item;
    });
  };

  React.useEffect(() => {
    const currentMenu = menuObject.find((item) => item.current);

    if (
      !currentMenu ||
      (currentMenu && !window.location.pathname.startsWith(currentMenu.href))
    ) {
      setMenuObject((v) => refreshMenu(v));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname, position]);

  const onClickMenuHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const newMenuObject = menuObject;

    newMenuObject.map((item) => {
      // Clear whole object
      item.current = false;
      if (item.children) {
        item.children.map((subItem) => (subItem.current = false));
      }

      // Set current marker
      if (item.id === e.currentTarget.id) {
        item.current = true;
      } else if (item.children) {
        item.children.map((subItem) => {
          if (subItem.id === e.currentTarget.id) {
            item.current = true;
            subItem.current = true;
          }
          return subItem;
        });
      }

      return item;
    });

    setMenuObject(newMenuObject);
  };

  return (
    <ViewComponent
      position={position!}
      menuObject={menuObject}
      sidebarOpen={sidebarOpen}
      setMenuObject={setMenuObject}
      setSidebarOpen={setSidebarOpen}
      onClickMenu={onClickMenuHandler}
    />
  );
};
